var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupTree"},[_c('myTree',{attrs:{"list":_vm.treeList,"ids":_vm.treeId,"label":"NAME","search":_vm.searchQuery,"is-open":_vm.isopen,"collapse-img":_vm.collapseImg,"expand-img":_vm.expandImg},on:{"getItemData":_vm.selectTreeItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }